module.exports = __webpack_public_path__ + "img/support.f0602b44.svg";